Router = App.loadClass 'core::Router'

class exports.FieldprintRouter extends Router

    prefix: 'Fieldprint'
    module_name: 'FieldprintRouter'

    register: () ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']

        @service 'grower::Angular/Fieldprint/FieldprintService', [
            '$http'
            '$state'
            '$rootScope'
        ]

        @service 'grower::Angular/Fieldprint/BulkDeleteService', [
            '$http',
            '$uibModal',
            '$state'
        ]

        @controller 'grower::Angular/Fieldprint/SidebarController', [
            '$scope'
            '$transitions'
            'Fieldprint.Services.FieldprintService'
            'Fieldprint.Services.BulkDeleteService'
            '$state'
            '$q'
            '$http'
            '$timeout'
            '$uibModal'
            '$ngModal'
            '$stateParams'
        ]

        @controller 'grower::Angular/Fieldprint/CopyFieldprintController', [
            '$scope'
            '$transitions'
            '$uibModalInstance'
            'Fieldprint.Services.FieldprintService'
            'fpcResultId'
            'year'
            'fpcResults'
            'fields'
        ]

        @controller 'grower::Angular/Fieldprint/OtherPracticesController', [
            '$scope'
            '$transitions'
            '$uibModalInstance'
            '$http'
            'selections'
            'survey'
        ]

        @controller 'grower::Angular/Fieldprint/CropResidueRemovedController', [
            '$scope'
            '$transitions'
            '$uibModalInstance'
            'Fieldprint.Services.FieldprintService'
        ]

        @controller 'grower::Angular/Fieldprint/LimeController', [
            '$scope'
            '$transitions'
            '$uibModalInstance'
            'Fieldprint.Services.FieldprintService'
        ]

        @controller 'grower::Angular/Fieldprint/StepsController', [
            '$scope'
            '$transitions'
            'Fieldprint.Services.FieldprintService'
            '$state'
            '$uibModal'
            '$http'
            '$ngModal'
        ], 'StepsController'

        for widget in [
            'ConservationPractices'
            'Drying'
            'Events'
            'ManagementSystem'
            'NutrientManagementTools'
            'Practices'
            'Transportation'
            'VegetativeCover'
        ]
            @controller "grower::Angular/Fieldprint/Widgets/#{widget}Controller", [
                '$scope'
                '$transitions'
                '$uibModal'
                '$http'
                'Fieldprint.Services.FieldprintService'
                '$state'
                '$anchorScroll' # This is hacky. I don't like that I'm injecting into every controller.
                '$location'
                '$timeout'
                '$ngModal'
            ], "#{widget}WidgetController"

        @controller 'grower::Angular/Fieldprint/ScoresController', [
            '$scope'
            '$transitions'
            'Fieldprint.Services.FieldprintService'
            '$state'
            '$http'
            '$transition$'
        ]

        # Bulk Delete Controller
        @controller 'grower::Angular/Fieldprint/BulkDeleteController', [
            '$scope',
            '$transitions',
            '$state',
            '$uibModalInstance',
            'Data',
            '$http'
        ]

    registerRoutes: ($stateProvider) ->
        $stateProvider
            .state 'grower.fieldprint',
                url: '/fieldprint/?:year/?:crop'
                templateUrl: 'backend/grower/fieldprint/sidebar'
                controller: 'Fieldprint.Controllers.SidebarController'

            .state 'grower.fieldprint.step',
                url: '/:id/step/:step'
                params:
                    id:
                        type: 'int'
                        dynamic: true
                        squash: false
                    step:
                        type: 'int'
                        value: 1
                        dynamic: true
                        squash: false
                views:
                    fullpage:
                        templateUrl: 'backend/grower/fieldprint/steps'

            .state 'grower.fieldprint.score',
                url: '/:id/score'
                params:
                    id:
                        type: 'int'
                        dynamic: false
                        squash: false
                views:
                    fullpage:
                        templateUrl: 'backend/grower/fieldprint/scores'
                        controller: 'Fieldprint.Controllers.ScoresController'
